import { render, staticRenderFns } from "./carreira.vue?vue&type=template&id=33f87f6e"
import script from "./carreira.vue?vue&type=script&lang=js"
export * from "./carreira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports